<script setup>
import { Label, Input, Select, Toggle, InputPrice, Upcoming } from "@components";

import { useSettings } from "@store/settings";
const $settings = useSettings();

import { useServiceItem } from "@store/serviceItem";
const $serviceItem = useServiceItem();

const isLocked = prebook_admin.is_pro != 1
</script>
<template>
	<div>
		<div v-if="$serviceItem.state.loading" class="grid items-center grid-cols-2 gap-5">
			<div v-for="i in 2" class="animate-pulse bg-[#F2F4F7] rounded-md h-[68px] w-full"></div>
		</div>
		<div v-else class="grid items-center grid-cols-1 md:grid-cols-2 gap-5">
			<div class="w-full">
				<Label>Duration</Label>
				<Input v-model="$serviceItem.service.meta.duration" min="0" type="number" class="mt-1.5">
					<template #after>
						<Select placeholder="Select" borderless class="w-20" :options="{ minute: 'Min', hour: 'Hour' }"
							v-model="$serviceItem.service.meta.duration_unit"></Select>
					</template>
					</Input>
				</div>
				<div></div>
				<div class="w-full">
					<Label>Price Type</Label>
					<Select placeholder="Select" class="mt-1.5"
						:options="{ fixed: 'Fixed', free: 'Free', none: 'None' }"
						v-model="$serviceItem.service.meta.price_type"></Select>
				</div>
				<div class="w-full" v-if="$serviceItem.service.meta.price_type == 'fixed'">
					<!-- {{ $serviceItem.service.meta.price }} -->
					<Label>Price</Label>
					<InputPrice v-model="$serviceItem.service.meta.price" class="mt-1.5" inputContainerClass="!py-3" />
				</div>
			</div>
			<!-- buffer time  -->
			<div class="w-full space-y-6 relative">
				<Upcoming />
				<div class="flex items-center justify-between w-full">
					<div class="flex flex-col gap-1">
						<div class="text-[#101828] text-lg font-semibold">Buffer Time</div>
						<div class="text-[#667085] text-sm font-normal">Assign team members to the service and manage
							commission </div>
					</div>
					<Toggle v-model="$serviceItem.service.meta.has_buffer_time"></Toggle>
				</div>
				<div class="grid grid-cols-2 items-center gap-5" v-if="1 == $serviceItem.service.meta.has_buffer_time || true == $serviceItem.service.meta.has_buffer_time">
					<div class="w-full">
						<Label>Before</Label>
						<Input v-model="$serviceItem.service.meta.pre_buffer" type="number" class="my-1.5">
						<template #after>
							<Select placeholder="Select" :options="{ minute: 'Min', hour: 'Hour' }"
								v-model="$serviceItem.service.meta.pre_buffer_unit" borderless class="w-20"></Select>
						</template>
						</Input>
					</div>
					<div class="w-full">
						<Label>After</Label>
						<Input v-model="$serviceItem.service.meta.post_buffer" type="number" class="my-1.5">
						<template #after>
							<Select placeholder="Select" :options="{ minute: 'Min', hour: 'Hour' }"
								v-model="$serviceItem.service.meta.post_buffer_unit" borderless class="w-20"></Select>
						</template>
						</Input>
					</div>
				</div>
			</div>
		</div>
	
</template>
<style></style>